import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './styles.scss';

const Video = ({ src, autoplay, title, className, ...other }) => {
  return (
    <div className={classNames('video', className)} {...other}>
      <iframe
        src={src}
        title={title}
        width="560"
        height="349"
        frameBorder="0"
        autoPlay={autoplay}
        allowFullScreen
      ></iframe>
    </div>
  );
};

Video.defaultProps = {
  src: null,
  autoplay: false,
  className: null,
};

Video.propTypes = {
  /** The URL of the video src. */
  src: PropTypes.string.isRequired,
  /** The title of the video */
  title: PropTypes.string.isRequired,
  /** Toggle autoplay */
  autoplay: PropTypes.bool,
  /** A custom class name */
  className: PropTypes.string,
};

export default Video;
